import { useCallback } from 'react';

import useIndustries from './query/company/useIndustries';

/**
 * 업종 코드로 업종 데이터를 반환
 * @returns { getIndustryByCode }
 */
export default function useGetIndustryByCode() {
  const { data: industries } = useIndustries();

  const getIndustryByCode = useCallback(
    (code: string) => industries?.find((industry) => industry.code === code),
    [industries],
  );

  return { getIndustryByCode };
}
